import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import RoteiroService from "service/producao/RoteiroService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const roteiroService = new RoteiroService();

export default function RoteiroListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Roteiros');

    const defaultFilters: DataTableFilterMeta = {
        codigoRoteiro: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        nome: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={roteiroService} urlService="/roteiro" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="roteiro" >
            <Column field="codigoRoteiro" header="Código" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" 
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}/>
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
        </BaseListagem>
    )
}